import React from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  useDisclosure
} from '@chakra-ui/react';

const HelpModal = ({ useDimacs }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button onClick={onOpen} variant="ghost" ml={2}>
        Nápoveda
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {useDimacs ? 'Pomoc s DIMACS formátom' : 'Pomoc s CNF formulkami'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {useDimacs ? (
              <>
                <Text mb={4}>
                  DIMACS je štandardizovaný textový formát pre SAT solvery. Každý riadok obsahuje buď komentár (začína znakom <code>c</code>),
                  hlavičku (začína <code>p</code>), alebo klauzuly.
                </Text>
                <Text>
                  <strong>Príklad zápisu:</strong> <br />
                  <code>p cnf 3 2</code><br />
                  <code>1 -2 0</code><br />
                  <code>2 3 0</code>
                </Text>
                <Text mt={3}>
                  Literály sú celé čísla, kde záporné číslo značí negáciu. Každá klauzula končí číslom <code>0</code>.
                </Text>
              </>
            ) : (
              <>
                <Text mb={4}>
                  CNF (Conjunctive Normal Form) je konjunkcia klauzúl, kde klauzula
                  je disjunkcia literálov.
                </Text>
                <Text>
                  <strong>Príklad zápisu:</strong> <br />
                  <code>(p ∨ ¬q) ∧ (¬p ∨ r)</code>
                </Text>
                <Text mt={3}>
                  Môžete používať znaky <code>∧</code>, <code>∨</code>, <code>¬</code>,
                  prípadne <code>^</code>, <code>v</code>.
                </Text>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} colorScheme="blue">
              Zatvoriť
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default HelpModal;
